document.addEventListener('click', function (e) {
    // Handle dropdown toggle
    let button = e.target.closest('.ld-button');
    if (button) {
        e.stopPropagation();
        let dropdown = button.closest('.ld-container');
        // Close all other dropdowns
        document.querySelectorAll('.ld-container').forEach(d => {
            if (d !== dropdown) d.classList.remove('ld-open');
        });
        dropdown.classList.toggle('ld-open');
        return; // No need to run the global close below
    }
    // Close all dropdowns if clicking outside
    document.querySelectorAll('.ld-container').forEach(d => d.classList.remove('ld-open'));
});

jQuery(function($){

    $('.offcanvas-fullscreen .menu-item-has-children').each(function(){
        let $item = $(this)

        // insert the toggle span right after the <a>
        $item.children('a').after('<span class="sub-menu-toggle" aria-expanded="false">+</span>');
    })

    // on click, toggle the submenu
    $('.offcanvas-fullscreen .sub-menu-toggle').on('click', function(e){
        e.preventDefault();

        let $toggle = $(this),
            $sub    = $toggle.siblings('.sub-menu');

        // slide the submenu
        $sub.slideToggle(200);

        // flip the symbol
        let expanded = $toggle.attr('aria-expanded') === 'true';
        $toggle
            .attr('aria-expanded', !expanded)
            .text(expanded ? '+' : '–')
    })
})